import BlockUi from '@availity/block-ui'
import React from 'react'
import { Spinner } from 'react-bootstrap'

type UiBloqueoProps = {
  blocking: boolean
  mensaje?: string
  children: React.ReactNode
  keepInView?: boolean
  styleProps?: React.CSSProperties
  mostrarLoader?: boolean 
}

const BlockUI: React.FC<UiBloqueoProps> = ({
  blocking,
  keepInView = false,
  mensaje = 'Procesando...',
  children,
  styleProps,
  mostrarLoader = true, // 👈 Valor por defecto: true
}) => {
  const loader = mostrarLoader ? (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        zIndex: 20000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'all',
        ...styleProps,
      }}
    >
      <Spinner animation="border" variant="primary" style={{ width: 30, height: 30 }} />
      <div
        style={{
          marginTop: '1.5rem',
          fontSize: '1.2rem',
          fontWeight: 500,
          color: '#333',
          textAlign: 'center',
          padding: '0 1rem',
          maxWidth: '90vw',
        }}
      >
        {mensaje}
      </div>
    </div>
  ) : undefined // 👈 Si mostrarLoader es false, no se renderiza el loader

  return (
    <div style={{ position: 'relative' }}>
      <BlockUi keepInView={keepInView} blocking={blocking} loader={loader}>
        <div style={{ pointerEvents: blocking ? 'none' : 'auto', opacity: blocking ? 0.6 : 1 }}>
          {children}
        </div>
      </BlockUi>
    </div>
  )
}

export default BlockUI
